import {notice} from "../UI/notice";
import Agent from "../Core/agent";
import {parseHTML} from "../Core/common";
import StarRating from "star-rating.js";
import JsTabs from "js-tabs";
import Swiper from 'swiper';
import {favoritesInit} from "../Favorites/favorites";


const compare = new Map(Object.entries(JSON.parse(localStorage.getItem('compare') || '{}')));

function setTotalCompare() {
    let totalCount = 0;
    compare.forEach(values => {
        totalCount += values.length;
    });
    document.querySelectorAll('.js_total_count_compare').forEach(item => {
        item.classList.remove('preloader');
        item.innerHTML = totalCount;
    });
}

setTotalCompare();

const compareEvent = (item, id, type) => {
    item.addEventListener('click', () => {
        let items = compare.get(type) || [];
        let index = items.indexOf(id);

        if (index >= 0) {
            items.splice(index, 1);
            notice('Удален из сравнения');
            document.querySelectorAll(`.js_add_compare[data-id="${id}"]`).forEach(item => {
                item.classList.remove('active');
                item.title = 'Добавить в избранное';
            });

        } else {
            items.push(id);
            notice('Добавлен в сравнение');
            document.querySelectorAll(`.js_add_compare[data-id="${id}"]`).forEach(item => {
                item.title = 'Удалить из сравнения';
                item.classList.add('active');
            });
        }

        compare.set(type, items);
        setTotalCompare();
        localStorage.setItem('compare', JSON.stringify(Object.fromEntries(compare.entries())));
    });
};

const removeBlock = element => {
    element.remove();
    if (!document.querySelector('.js_load_compare')) {
        document.querySelector('.section.compare').classList.remove('d-none');
    }
};

const tabInit = item => {

    let btns = item.querySelector('.custom-tabs');
    let container = item.querySelectorAll('.custom-container');
    // item.querySelectorAll('.js_add_compare').forEach(btn => {
    //     const id = btn.dataset.id;
    //     const type = btn.dataset.type;
    //     let items = compare.get(type) || [];
    //     let index = items.indexOf(id);
    //
    //     if (index >= 0) {
    //         items.splice(index, 1);
    //         compare.set(type, items);
    //     }
    // });
    //
    // setTotalCompare();
    // localStorage.setItem('compare', JSON.stringify(Object.fromEntries(compare.entries())));

    if (btns) {
        btns.querySelector('.custom-tab').classList.add('active');

        container.forEach(item => {
            item.querySelector('.custom-item').classList.add('active');
        });

        btns.querySelectorAll('.custom-tab').forEach(btn => {
            btn.addEventListener('click', () => {
                btns.querySelectorAll('.custom-tab').forEach(btn => {
                    btn.classList.remove('active');
                });
                btn.classList.add('active');
                let data = btn.dataset.tab;
                item.querySelectorAll('.custom-item').forEach(item => {
                    item.classList.remove('active');
                });
                item.querySelectorAll(`.custom-item[data-tab="${data}"]`).forEach(item => {
                    item.classList.add('active');
                });
            });

        });
    }

};

const deleteItem = (item, swiperCompare) => {
    const id = item.dataset.id;
    const type = item.dataset.type;
    const tabBlock = item.closest('.slider-tabs');
    const block = item.closest('.section');

    item.closest('.js_item').remove();
    document.querySelectorAll(`.swiper-slide[data-group="${id}"]`).forEach(item => {
        item.remove();
    });

    swiperCompare.update();

    let items = compare.get(type) || [];
    let index = items.indexOf(id);
    if (index >= 0) {
        items.splice(index, 1);
        notice('Удален из сравнения');

        compare.set(type, items);
        setTotalCompare();
        localStorage.setItem('compare', JSON.stringify(Object.fromEntries(compare.entries())));

        if (tabBlock) {
            const currentTab = tabBlock.querySelector('.custom-tab.active');
            let article = currentTab.dataset.tab;

            let currentTabContent = tabBlock.querySelector(`.js_custom-item[data-tab="${article}"]`);
            let curr = tabBlock.querySelector(`.custom-item[data-tab="${article}"]`);
            if (!currentTabContent.querySelector('.js_item')) {
                currentTabContent.remove();
                currentTab.remove();
                curr.remove();

                let firstTab = tabBlock.querySelector(".custom-tab");
                if (firstTab) {
                    firstTab.click();
                } else {
                    removeBlock(block);
                }
            }
        } else {
            if (!block.querySelector('.js_item')) {
                removeBlock(block);
            }
        }
    }
};

export const compareInit = (selector) => {
    document.querySelectorAll(selector).forEach(item => compareInitItem(item));

    document.querySelectorAll('.js_load_compare').forEach(item => {
        let type = item.dataset.type;
        let items = compare.get(type);
        if (items && items.length) {
            Agent.post(`/compare/${type}.html`, JSON.stringify(items), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(e => e.json())
                .then(e => {
                    item.classList.remove('preloader');
                    if (e.success) {
                        item.append(parseHTML(e.data));
                        tabInit(item);

                        favoritesInit('.js_add_favorites');


                        item.querySelectorAll('.swiper').forEach(swipers => {
                            let swiperCompare = new Swiper(swipers, {
                                slidesPerView: 2,
                                spaceBetween: 10,
                                watchSlidesVisibility: true,
                                slideActiveClass: "active",
                                observer: true,
                                observeParents: true,
                                breakpoints: {
                                    576: {
                                        slidesPerView: 2,
                                        spaceBetween: 20
                                    },
                                    992: {
                                        slidesPerView: 3,
                                        spaceBetween: 30
                                    },
                                    1200: {
                                        slidesPerView: 4,
                                        spaceBetween: 30
                                    },
                                    1524: {
                                        spaceBetween: 40,
                                        slidesPerView: 4,
                                    },
                                }
                            });
                            swipers.querySelectorAll('.js_delete_item').forEach(btn => btn.addEventListener('click', deleteItem.bind(null, btn, swiperCompare)));
                        });


                        item.querySelectorAll('.star-rating').forEach(item => {
                            new StarRating(item, {
                                clearable: true,
                                tooltip: false,
                                maxStars: 5,
                            });
                        });
                    } else {
                        removeBlock(item.closest('.section'));
                    }
                })
                .catch(e => console.log(e));
        } else {
            removeBlock(item.closest('.section'));
        }
    });
};

export const compareInitItem = item => {

    if (!item.classList.contains('js_compare_initialized')) {
        item.classList.add('js_compare_initialized');

        const id = item.dataset.id;
        const type = item.dataset.type;

        let items = compare.get(type) || [];
        let index = items.indexOf(id);

        if (index >= 0) {
            item.classList.add('active');
            item.title = 'Удалить из избранного';
        }

        compareEvent(item, id, type);
    }
};